<template>
    <div>
        <div class="container">
            <div class="card mt-4">
                <h3 class="card-header">Login</h3>
                <div class="card-body">

                    <div v-if="errors">
                        <div v-for="error of errors" :key="error.message">
                            <div class="alert alert-dismissible fade show" role="alert" :class="error.type">
                                {{error.message}}
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <form @submit.prevent="login">
                        <div class="form-group">
                            <label for="user">Username</label>
                            <input class="form-control" id="user" v-model="username" required>
                        </div>
                        <div class="form-group">
                            <label for="pass">Password</label>
                            <input type="password" class="form-control" id="pass" v-model="password" required>
                        </div>

                        <div class="form-group">
                            <button class="form-control btn-outline-primary mt-4" type="submit" :disabled="loading">
                                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                                <span v-if="!loading">Login</span>
                                <span v-else>Loading...</span>
                            </button>

                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                username: "",
                password: "",
                errors: [],
                loading: false
            }
        },
        methods: {
            pushError(error) {
                this.removeError(error.message);
                this.errors.push(error)
            },
            removeError(error_message) {
                for( let i = 0; i < this.errors.length; i++) {
                    if ( this.errors[i].message === error_message) {
                        this.errors.splice(i, 1)
                    }
                }
            },
            login() {

                // Form validation
                if(this.username === "") {
                    this.pushError({message: "Username is required", type: 'alert-warning'});
                    return 0
                } else {
                    this.removeError("Username is required")
                }
                if(this.password === "") {
                    this.pushError({message: "Password is required", type: 'alert-warning'});
                    return 0
                } else {
                    this.removeError("Password is required")
                }

                this.loading = true;

                // todo: tryRefresh for obtain User details?

                // Obtain Auth Token
                this.$store.dispatch('obtainToken', {
                    username: this.username,
                    password: this.password,
                }).then( () => {
                    this.$store.dispatch('obtainUserDetails').then(() => {
                        this.$router.push({name: 'dashboard'}).catch(e => {
                            // eslint-disable-next-line no-console
                            console.log(e);
                            this.loading = false
                        })
                    }).catch(e => {

                        this.loading = false;
                        // eslint-disable-next-line no-console
                        console.log(e)
                    })
                }).catch(e => {

                    this.loading = false;

                    // Handle Errors
                    if(e.response.status === 401) {
                        this.pushError({message: "Username or Password is incorrect", type: 'alert-danger'})
                    } else {
                        this.pushError(
                            {
                                message: "Error: " + e.response.statusText,
                                type: 'alert-danger'
                            })
                    }

                })
            }
        },

    }
</script>

<style scoped>

</style>